@if (hasLeakedPassword()) {
  <key-note type="danger">{{ 'App_PasswordLeaked' | translate }}</key-note>
}
<router-outlet></router-outlet>
